import React, { type ComponentProps, forwardRef } from 'react';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { typography } from 'styled-system';

import { componentVariant } from '../../internal/styles/componentVariant';
import sx from '../../internal/styles/sx';
import Typography from '../Typography';
import type { HeadingProps } from './types';

const options = {
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== 'type',
};
const StyledHeading = styled(Typography, options)<HeadingProps>(
  typography,
  componentVariant({
    prop: 'type',
    variants: {
      '1': {
        fontSize: 'headings.1',
        lineHeight: 'headings.1',
        letterSpacing: 'heading.1',
      },
      '2': {
        fontSize: 'headings.2',
        lineHeight: 'headings.2',
        letterSpacing: 'heading.2',
      },
      '3': {
        fontSize: 'headings.3',
        lineHeight: 'headings.3',
        letterSpacing: 'heading.3',
      },
      '4': {
        fontSize: 'headings.4',
        lineHeight: 'headings.4',
        letterSpacing: 'heading.4',
      },
      '5': {
        fontSize: 'headings.5',
        lineHeight: 'headings.5',
        letterSpacing: 'heading.5',
      },
      '6': {
        fontSize: 'headings.6',
        lineHeight: 'headings.6',
        letterSpacing: 'heading.6',
      },
    },
  }),
  { display: 'block' },
  sx
);

const Heading = forwardRef<
  HTMLDivElement,
  ComponentProps<typeof StyledHeading>
>((props, ref) => <StyledHeading as="div" {...props} ref={ref} />);

export default Heading;
